import { Icon } from '@app/components';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  DocumentIcon,
  DragAndDrop,
  FileName,
  FileTypes,
  ImportFromPc,
  UploadBody,
  UploadContainer,
} from '@app/modules/transaction-form/documents-component';
import { ErrorMessage } from '@app/modules/transaction-form/transactions-form-components';
import { DocErrorType, FileType } from '@app/types/documents';
type DocumentTypes = {
  disable: boolean;
  docType?: any;
  updateFiles: (e: any) => void;
  isSubmitted?: boolean;
  uploadText?: string;
  uploadProgress?: number;
  selectedFile?: any;
  showError?: DocErrorType;
};
export default function DocumentsUpload({
  disable,
  updateFiles,
  uploadProgress,
  isSubmitted,
  uploadText,
  selectedFile,
  showError,
}: DocumentTypes) {
  const fileTypes: string = '.PDF, .PNG, .JPG, .CSV, .XLS, .DOC';
  const [files, setFiles] = React.useState<any>(selectedFile || []);
  const [errorMessage, updateErrorMessage] = React.useState(
    showError && showError.show ? showError.message : '',
  );
  const MAX_SIZE: number = 20000000000;
  const MAX_FILES: number = 1;

  React.useEffect(() => {
    updateErrorMessage(showError && showError.show ? showError.message : '');
  }, [showError]);
  const onDrop = useCallback(
    acceptedFiles => {
      let uploadedFile: FileType[] = acceptedFiles.map(
        (file: File, key: number) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            title: file.name,
            contentType: file.type,
          }),
      );
      setFiles(uploadedFile);
      updateFiles(uploadedFile);
    },
    [updateFiles],
  );
  function remove() {
    setFiles([]);
    updateFiles([]);
  }
  const { getRootProps, getInputProps, fileRejections, open } = useDropzone({
    onDrop,
    accept: fileTypes,
    maxSize: MAX_SIZE,
    maxFiles: MAX_FILES,
    noClick: true,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }: any) => (
    <li key={file.path}>
      {errors.map((e: any, key: number) => (
        <>
          {e.code === 'too-many-files' ? (
            <li key={e.code}>Only one file is allowed at a time</li>
          ) : e.code === 'file-too-large' ? (
            <li key={e.code}>File is larger than 20GB</li>
          ) : e.code === 'file-invalid-type' ? (
            <li key={e.code}>
              Please upload a valid file format. PDF, PNG, JPG, CSV, XLS, DOC
              file types are allowed.
            </li>
          ) : (
            <li key={e.code}>{e.message}</li>
          )}
        </>
      ))}
    </li>
  ));

  return (
    <>
      <UploadContainer {...getRootProps()}>
        <input {...getInputProps()} />
        <UploadBody>
          <DocumentIcon>
            <Icon name="documentIcon" />
          </DocumentIcon>
          {files && files.length ? (
            files.map((file: any, key: number) => {
              return (
                <>
                  <FileName>
                    {file.name}{' '}
                    {!isSubmitted && (
                      <strong style={{ color: 'red' }} onClick={() => remove()}>
                        Remove
                      </strong>
                    )}
                  </FileName>
                  <FileName>{uploadText}</FileName>
                  {isSubmitted && (
                    <div
                      id="myProgress"
                      style={{
                        display: 'none',
                        width: '150px',
                        background: '#E6E7ED',
                        marginTop: '5px',
                        borderRadius: '40px',
                      }}>
                      <div
                        id="myBar"
                        style={{
                          width: '1%',
                          height: '20px',
                          borderRadius: '40px',
                          textAlign: 'center',
                          background:
                            'linear-gradient(270deg, #FFB900 0%, rgba(227, 174, 32, 0.5) 109.69%)',
                        }}>
                        {uploadProgress}%
                      </div>
                    </div>
                  )}
                </>
              );
            })
          ) : (
            <>
              <DragAndDrop>Drag and drop some file</DragAndDrop>
              <FileTypes>File types: {fileTypes}</FileTypes>
              <p>Or</p>
              <ImportFromPc onClick={open}>
                Upload from your computer
              </ImportFromPc>
            </>
          )}
        </UploadBody>
      </UploadContainer>
      <ErrorMessage>
        <ul>{fileRejectionItems}</ul>
        <ul>{errorMessage}</ul>
      </ErrorMessage>
    </>
  );
}
